import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import Staff1 from "../../image/faculty/staff1.jpg";
import ProgramOfferCard from "../../components/ProgramOfferCard";
import { Helmet } from "react-helmet-async";
import tertiaryPic from "../../image/jmif-tertiary-group.png";
export default function TertiaryEducation() {
  const [openCard, setOpenCard] = useState(1);
  const [activeCard, setActiveCard] = useState(1);

  // Handler to open a specific card
  const handleCardClick = (id) => {
    setActiveCard(id);
    setOpenCard(id);
    // setOpenCard(openCard === id ? null : id);
  };

  return (
    <div>
      {" "}
      <Helmet>
        <title>Tertiary Education | Jamiatu Marawi Al-Islamia Foundation</title>
        <meta
          name="description"
          content="Jamiatu Marawi Al-Islamia Foundation (JMIF) fosters intellectual growth by blending Islamic values with modern education to develop future leaders and scholars."
        />
        <meta
          name="keywords"
          content="Jamiatu Marawi Al-Islamia Foundation, JMIF, Marawi School, education "
        />
        <link
          rel="canonical"
          href="https://jmif-73f1a.web.app/academics/tertiary-education"
        />{" "}
        <meta
          property="og:title"
          content="Academic | Jamiatu Marawi Al-Islamia Foundation"
        />{" "}
        <meta
          name="og:description"
          content="Jamiatu Marawi Al-Islamia Foundation, JMIF, Marawi School, education "
        />
        <meta property="og:image" content={tertiaryPic} />
        <meta
          property="og:url"
          content="https://jmif-73f1a.web.app/academics/"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main className="">
        {/* section 1 */} {/* title page */}
        <PageHeader
          pageTitle={"TERTIARY EDUCATION"}
          description={
            " Read more about us. Our history, mission, vision and many other you might love."
          }
        />
        <div className=" responsive-padding ">
          <div className="my-5 flex flex-col gap-3">
            <h1 className=" font-montserrat font-semibold text-2xl md:text-3xl laptopSm:text-4xl text-text-normal">
              About
            </h1>
            <p className="font-notoSans font-light text-sm leading-6 tracking-[0.06em] text-grey-normal">
              JMIF’s Basic Education program, from Grade 1 to Grade 12, fosters
              academic excellence and character development in a supportive
              environment. With a blend of core subjects and co-curricular
              activities, we encourage critical thinking, creativity, and
              effective communication. Our focus on values and community service
              nurtures leadership and social responsibility, ensuring students
              are well-prepared for higher education and future success.
            </p>

            <Button
              text={"Enroll Now"}
              type={"none"}
              arrow={false}
              navigateTo={"none"}
            />
          </div>
          <div className="my-16 ">
            <h1 className="capitalize mb-8 font-montserrat font-bold text-2xl laptopSm:text-[32px] leading-4 text-text-dark">
              Programs Offered
            </h1>
            <div
              onMouseLeave={() => {
                setOpenCard(activeCard);
              }}
              className="flex flex-col laptopSm:flex-row gap-4 justify-between"
            >
              <ProgramOfferCard
                number={1}
                isOpen={openCard === 1}
                backgroundImage={Staff1}
                onCardClick={() => handleCardClick(1)}
                title={
                  "Bachelor of Science in Elementary Education, major in General 				Education"
                }
                description="JMIF’s Basic Education program, 
                from Grade 1 to Grade 12, fosters academic excellence 
                and character development in a supportive environment.
                 With a blend of core subjects and co-curricular activities,
                we encourage critical thinking, creativity, and effective communication. 
                Our focus on values and community service nurtures
                 leadership and social responsibility, ensuring students
                  are well-prepared for higher education and future success."
                setOpenCard={setOpenCard}
                activeCard={activeCard}
              />
              <ProgramOfferCard
                number={2}
                backgroundImage={Staff1}
                isOpen={openCard === 2}
                onCardClick={() => handleCardClick(2)}
                title={
                  " Bachelor of Science in Secondary Education major in English"
                }
                description={"...."}
                setOpenCard={setOpenCard}
                activeCard={activeCard}
              />
              <ProgramOfferCard
                number={3}
                backgroundImage={Staff1}
                isOpen={openCard === 3}
                onCardClick={() => handleCardClick(3)}
                title={"Bachelor of Science in Nursing (BSN)"}
                description={"...."}
                setOpenCard={setOpenCard}
                activeCard={activeCard}
              />
              <ProgramOfferCard
                number={4}
                backgroundImage={Staff1}
                isOpen={openCard === 4}
                onCardClick={() => handleCardClick(4)}
                title={"Bachelor of Science in Midwifery (BSM)"}
                description="JMIF’s Basic Education program, 
                from Grade 1 to Grade 12, fosters academic excellence 
                and character development in a supportive environment.
                 With a blend of core subjects and co-curricular activities, we encourage critical thinking, creativity, and effective communication. Our focus on values and community service nurtures leadership and social responsibility, ensuring students are well-prepared for higher education and future success."
                setOpenCard={setOpenCard}
                activeCard={activeCard}
              />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
